import React from "react";
import Button from "./Button";

export function UploadFileButton({ onClick, disabled }) {
  return (
    <Button
      type="primary"
      label="Upload file"
      size="small"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
